"use client";

import { cx } from "@linaria/core";
import { useBlock } from "timvir/core";
import * as React from "react";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentProps<typeof Root> {
  caption?: React.ReactNode;

  /**
   * How much the component should extend out of its original box. When number,
   * it's the number of pixels. When a string, must evaluate to a CSS <length>
   * (can be inline or reference to a CSS variable).
   */
  bleed?: string | number;
  BackdropProps?: React.ComponentPropsWithoutRef<"div">;
}
function Exhibit(props: Props, ref: React.ForwardedRef<React.ComponentRef<typeof Root>>) {
  const block = useBlock(props);
  const {
    caption,
    bleed,
    BackdropProps,
    children,
    className,
    style,
    ...rest
  } = block.props;
  return <Root ref={ref} className={cx("timvir-b-Exhibit", className, classes.root)} style={{
    ...style,
    [cssVariables.bleed]: typeof bleed === "number" ? `${bleed}px` : undefined
  }} {...rest}>
      <div className={cx("timvir-b-Exhibit-container", classes.container)} {...BackdropProps} style={{
      border: bleed === 0 ? "none" : `1px solid var(${cssVariables.borderColor})`,
      ...BackdropProps?.style
    }}>
        {children}
      </div>

      {caption && <div className={cx("timvir-b-Exhibit-caption", classes.caption)}>{caption}</div>}
    </Root>;
}
export default React.forwardRef(Exhibit);
const cssVariables = {
  bleed: "--timvir-b-Exhibit-bleed",
  borderColor: "--timvir-b-Exhibit-borderColor",
  background: "--timvir-b-Exhibit-background"
};
const classes = {
  root: "r1nql2f9",
  container: "c4ji594",
  caption: "cf43jjx"
};

require("./Exhibit.linaria.module.css!=!../../../../node_modules/.pnpm/@wyw-in-js+webpack-loader@0.6.0_webpack@5.99.5/node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Exhibit.tsx");